import { LucideIcon } from 'lucide-react';
import { SVGProps, forwardRef } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props extends SVGProps<SVGSVGElement> {
    icon: LucideIcon;
    size?: string;
    color?: string;
}

const Icon = forwardRef<SVGSVGElement, Props>(
    ({ icon: IconComponent, size = 'size-5', color, className, ...props }, ref) => {
        return <IconComponent ref={ref} className={cn(size, color, className)} {...props} />;
    }
);

Icon.displayName = 'Icon';

export default Icon;
